<app-common-modal-popup [modelSize]="'modal-lg'" class="">
  <div class="" modelheadertext>{{ "Create team" | translate }}</div>
  <div class="container-fluid"  modeldata>
    <form action="" [formGroup]="teamForm">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-group pb-2">
            <label for="teamName" class="pb-2">{{
              "Team Name " | translate
            }}</label>  <span>*</span>
            <input
              type="text"
              class="form-control inputfields"
              id="teamName"
              aria-describedby="name"
              formControlName="teamName"
              autocomplete="off"
            />

            <span class="text-danger validation"
            *ngIf="(teamformControl.teamName.touched || submitted)&& teamformControl.teamName.errors?.required">
            *{{'Team name is required'|translate}} 
          </span>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group pb-2">
            <label for="manager" class="pb-2">{{
              "Manager " | translate
            }}</label> <span>*</span>
              <select
            class="form-select taskspanel" 
            id="cname"  
            formControlName="manager"
            (change)="getManagerDetails($event)"
          >
            <option value="0">Select</option>
            <option
              value="{{ c.id}}"
              *ngFor="let c of empList"
            >
              {{ c.name }}
            </option>
          </select>
          <span class="text-danger validation"
          *ngIf="(teamForm.get('manager').touched || submitted) && teamForm.get('manager').value === '0'">
          *{{ 'Please select manager' | translate }}
        </span>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group pb-2">
            <label for="description" class="pb-2">{{
              "Description " | translate
            }}</label> <span>*</span>
             <input
            type="text"
            class="form-control inputfields"
            id="description"
            aria-describedby="name"
            formControlName="description"
            autocomplete="off"
          />
            <span class="text-danger validation"
            *ngIf="(teamformControl.description.touched || submitted)&& teamformControl.description.errors?.required">
            *{{'Description required'|translate}} 
          </span>
          </div>
        </div>
        <div class="d-flex align-items pt-4 pb-2">
          <button mat-raised-button type="submit" class="cancelbtn" (click)="submit()">
            {{ "SAVE" | translate }}
          </button>
          <button
            mat-raised-button
            type="button"
            class="cancelbtn bg-secondary ms-3"
            (click)="closeModal()"
          >
            {{ "CANCEL" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</app-common-modal-popup>
